import React, { useMemo, useEffect } from 'react';
import { useStyle } from '@magento/venia-ui/lib/classify';
import { isEmailValid } from '@magento/venia-ui/lib/util/formValidators';
import { useFieldState, useFormApi, useFormState } from 'informed';
import defaultClasses from './orderInformation.module.css';
import Field from '../../../../overrides/venia-ui/components/Field';
import TextInput from '@magento/venia-ui/lib/components/TextInput';

var OrderInformation = function OrderInformation(_ref) {
  var _customer$orders2, _customer$orders2$ite, _customer$orders2$ite2;

  var propClasses = _ref.classes,
      order = _ref.order,
      customer = _ref.customer,
      orderDetails = _ref.orderDetails;
  var shippingAddress = useMemo(function () {
    var _customer$orders, _customer$orders$item, _customer$orders$item2;

    return customer === null || customer === void 0 ? void 0 : (_customer$orders = customer.orders) === null || _customer$orders === void 0 ? void 0 : (_customer$orders$item = _customer$orders.items) === null || _customer$orders$item === void 0 ? void 0 : (_customer$orders$item2 = _customer$orders$item[0]) === null || _customer$orders$item2 === void 0 ? void 0 : _customer$orders$item2.shipping_address;
  }, [customer === null || customer === void 0 ? void 0 : (_customer$orders2 = customer.orders) === null || _customer$orders2 === void 0 ? void 0 : (_customer$orders2$ite = _customer$orders2.items) === null || _customer$orders2$ite === void 0 ? void 0 : (_customer$orders2$ite2 = _customer$orders2$ite[0]) === null || _customer$orders2$ite2 === void 0 ? void 0 : _customer$orders2$ite2.shipping_address]);
  var classes = useStyle(defaultClasses, propClasses);

  var _useFieldState = useFieldState('email'),
      value = _useFieldState.value;

  var _useFormState = useFormState(),
      values = _useFormState.values;

  var _useFormApi = useFormApi(),
      resetField = _useFormApi.resetField;

  useEffect(function () {
    if (value === '' || value === undefined) resetField('email');
  }, [value]);

  var customValidate = function customValidate() {
    return values !== null && values !== void 0 && values.email && (values === null || values === void 0 ? void 0 : values.email) !== '' ? isEmailValid(values === null || values === void 0 ? void 0 : values.email) : undefined;
  };

  return React.createElement("div", {
    className: classes.orderContainer
  }, React.createElement("h5", {
    className: classes.sectionTitle
  }, "Order Information"), React.createElement("div", {
    className: classes.infoContainer
  }, React.createElement("div", null, React.createElement("p", {
    className: classes.label
  }, "Order#"), React.createElement("p", null, order === null || order === void 0 ? void 0 : order.order_number)), React.createElement("div", null, React.createElement("p", {
    className: classes.label
  }, "Name"), React.createElement("p", null, "".concat(customer === null || customer === void 0 ? void 0 : customer.firstname, " ").concat(customer === null || customer === void 0 ? void 0 : customer.lastname))), React.createElement("div", null, React.createElement("p", {
    className: classes.label
  }, "Email"), React.createElement("p", null, customer === null || customer === void 0 ? void 0 : customer.email)), React.createElement("div", null, React.createElement("p", {
    className: classes.label
  }, "Additional notification email"), React.createElement(Field, {
    id: "email",
    label: "email"
  }, React.createElement(TextInput, {
    validate: customValidate,
    autoComplete: "email",
    field: "email",
    placeholder: "Enter email",
    validateOnBlur: value !== '' || value !== undefined ? true : false
  }))), React.createElement("div", null, React.createElement("p", {
    className: classes.label
  }, "Order Shipping Address"), !(orderDetails !== null && orderDetails !== void 0 && orderDetails.shipping_address_1) ? React.createElement("p", null, "No shipping address.") : React.createElement(React.Fragment, null, React.createElement("p", null, orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.shipping_customer_name, React.createElement("br", null), " ", orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.shipping_address_1, React.createElement("br", null), ' ', "".concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.shipping_address_city, ", ").concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.shipping_address_state, ", ").concat(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.shipping_address_zip), React.createElement("br", null), 'US')))));
};

export default OrderInformation;